<script>
import ExpandableContainer from '@/V2/components/expandable-container/ExpandableContainer.vue';
import {
  iButton,
  iButtonStyles,
  iButtonSizes,
  iButtonTypes,
  iSpinner,
  iKeyIcon,
  iKeyIconShape,
  iKeyIconStyle,
  iKeyIconType,
  iKeyIconSize,
} from '@inscribe/signal';

export default {
  components: {
    ExpandableContainer,
    iButton,
    iSpinner,
    iKeyIcon,
  },
  props: {},
  data() {
    return {
      iButtonStyles,
      iButtonSizes,
      iButtonTypes,
      iKeyIconShape,
      iKeyIconStyle,
      iKeyIconType,
      iKeyIconSize,
    };
  },
  methods: {
    onViewDocumentsClick() {
      this.$router.push({
        name: 'customer-documents',
        params: {
          customerId: this.$route.params.customerId,
        },
      });
    },
  },
};
</script>

<template>
  <div
    class="customer-fraud-uploading d-flex flex-row align-items-center i-radius-2xl i-p-8"
  >
    <i-key-icon
      icon="medium_upload_1"
      :size="iKeyIconSize.MEDIUM"
      :shape="iKeyIconShape.SQUARE"
      :type="iKeyIconType.NEUTRAL"
      :icon-style="iKeyIconStyle.OUTLINE"
      class="i-mr-6"
    />
    <div class="text d-flex flex-column flex-grow-1">
      <div class="text-title i-text-button-2 i-text-neutral-120">
        Documents uploading
      </div>
      <div class="text-subtitle i-text-body-2 i-text-neutral-110">
        Processing...
      </div>
    </div>
    <i-button
      text="View Documents"
      :size="iButtonSizes.SMALL"
      :type="iButtonTypes.NEUTRAL"
      :button-style="iButtonStyles.OUTLINE"
      @button-click="onViewDocumentsClick"
    />
    <i-spinner size="md" class="i-ml-10" />
  </div>
</template>

<style lang="scss" scoped>
.customer-fraud-uploading {
  border: 1px solid $light-neutral-60;
}
</style>
